var _defs, _circle, _rect, _g, _rect2, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChange(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 180.29 180.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{stroke-width:5.26px;}.b,.c,.d,.e{stroke-miterlimit:10;}.b,.c,.d,.f{fill:none;stroke:#da783c;}.c{stroke-width:1.91px;}.d{stroke-width:5.56px;}.g{fill:#da783c;}.e{fill:#dfd7cd;stroke:#dfd7cd;stroke-width:7.98px;}.f{stroke-linecap:round;stroke-linejoin:round;stroke-width:5.56px;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 92.98,
    cy: 88.32,
    r: 67.38
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 8.88,
    y: 36.17,
    width: 87.52,
    height: 42.51,
    transform: "translate(16.55 -11.61) rotate(14.91)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 60.71,
    y1: 2.78,
    x2: 52.49,
    y2: 33.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 83.5,
    y1: 41.99,
    x2: 52.63,
    y2: 33.77
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 83.9,
    y: 103.2,
    width: 87.52,
    height: 42.51,
    transform: "translate(36.32 -28.66) rotate(14.91)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 94.64,
    y1: 136.5,
    x2: 124.48,
    y2: 147.93
  }), /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 113.06,
    y1: 177.95,
    x2: 124.49,
    y2: 148.11
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M126.75,78.39v31.99c0,2.27-1.84,4.1-4.1,4.1H63.14c-2.27,0-4.1-1.84-4.1-4.1v-31.99c0-2.27,1.84-4.1,4.1-4.1h16.95v-9.32c0-1.46,1.18-2.64,2.64-2.64h20.51c1.46,0,2.64,1.18,2.64,2.64v9.32h16.76c2.27,0,4.1,1.84,4.1,4.1Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 92.89,
    cy: 93.55,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 113.11,
    cy: 82.18,
    r: 3.35
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChange);
export default __webpack_public_path__ + "static/media/change.3f3b308e03a1a4778d73888e46a9c0dd.svg";
export { ForwardRef as ReactComponent };